import { useGetAuthUser } from "@/api/get-user";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export function useIsModerator() {
  const { data: user, isSuccess: isUserSuccess } = useGetAuthUser();
  const moderatorIds = useVidyoStore((state) => state.moderatorIds);

  if (!isUserSuccess) {
    return false;
  }

  return moderatorIds.includes(user.sub || "");
}
